import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import IFooterProps from "./IFooter";
import Footer from "./Footer";

import * as DYNAMIC_FORM_ACTIONS from "../DynamicForm/actionCreators";

function mapStateToProps(state) {
    return {
        isTechSupportPopUpShown: state.dynamicFormInfo.global.isTechSupportPopUpShown,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(DYNAMIC_FORM_ACTIONS, dispatch),
    };
}
export default connect<IFooterProps, {}>(mapStateToProps, mapDispatchToProps)(Footer);
